/**
 * [INPUT]: 依赖 TanStack Query、ThemeProvider、ErrorBoundary、AppRouter 与 PwaUpdate
 * [OUTPUT]: 对外提供 App 应用组合根
 * [POS]: app 的依赖装配点，只定义跨页面 provider 和全局故障边界
 * [PROTOCOL]: 变更时更新此头部，然后检查 AGENTS.md
 */

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { ErrorBoundary } from './ErrorBoundary'
import { PwaUpdate } from './PwaUpdate'
import { AppRouter } from './router'
import { ThemeProvider } from './ThemeProvider'

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000, retry: 1, refetchOnWindowFocus: false } },
})

export function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <AppRouter />
          <PwaUpdate />
        </QueryClientProvider>
      </ThemeProvider>
    </ErrorBoundary>
  )
}
